import { ArrowRight } from 'lucide-react';
import { Reveal } from '@/components/Reveal';
import { LangLink } from '@/i18n/LangContext';

export const CtaBanner = ({ title, text, label, href = '/contatti' }) => (
  <Reveal>
    <section data-testid="cta-banner" className="bg-brand-deep text-white my-16 md:my-24 rounded-xl overflow-hidden">
      <div className="mx-auto max-w-site px-5 md:px-8 py-14 md:py-20 grid md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-8">
          <h2 className="font-heading text-3xl md:text-4xl font-bold tracking-tight leading-tight mb-4" data-testid="cta-banner-title">{title}</h2>
          <p className="text-white/75 text-base md:text-lg leading-relaxed max-w-2xl">{text}</p>
        </div>
        <div className="md:col-span-4 md:text-right">
          <LangLink
            to={href}
            data-testid="cta-banner-button"
            className="inline-flex items-center gap-2 bg-brand-light text-brand-deep px-7 py-4 text-sm font-bold rounded-lg hover:bg-white transition-colors duration-200 group"
          >
            {label}
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
          </LangLink>
        </div>
      </div>
    </section>
  </Reveal>
);
